import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const INITIAL_STATE_VEHICLES_MAINTENANCE = {
  'vehiclesMaintenance': [],
  'loading': false,
};

export const vehiclesMaintenance = (state, action) => {
  return createReducer(INITIAL_STATE_VEHICLES_MAINTENANCE, {
    [ActionTypes.FETCHING_VEHICLES_MAINTENANCE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLES_MAINTENANCE]: (state, action) => ({
      ...state,
      'loading': false,
      'vehiclesMaintenance': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLES_MAINTENANCE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'vehiclesMaintenance': [],
    }),
  })(state, action);
};
